export default __webpack_public_path__ + "/image/pepr2vis_cover_e7b5093.png";